import { isAxiosError } from "axios";
import api from "../api";
import { literals } from "@/constants/literals";

interface ExistsParams {
  area: string;
  step: string;
  sapWorkOrder?: string;
  orderIn?: string;
  serialIn?: string;
  customerOrderServ?: string;
  document9r1?: string;
  customerOrderNoserv?: string;
  customer?: string;
}

export const askOrderExist = async (params: ExistsParams) => {
  try {
    const queryParams = [];
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined) queryParams.push(`${key}=${value}`);
    }
    const url =
      "orders/exists" + (queryParams.length ? "?" + queryParams.join("&") : "");
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const createOrder = async (data: {
  orderIn?: string;
  area: string;
  step: string;
  serialOut?: string;
  orderOut?: string;
  customerOrderNoserv?: string;
  serialIn?: string;
  customer?: string;
  packagingReference?: string;
  sapWorkOrder?: string;
  customerOrderServ?: string;
  document9r1?: string;
  originalCustomer?: string;
}) => {
  try {
    const existParams: ExistsParams = {
      area: data.area,
      step: data.step,
    };
    if (data.sapWorkOrder) existParams.sapWorkOrder = data.sapWorkOrder;
    if (data.orderIn) existParams.orderIn = data.orderIn;
    if (data.serialIn) existParams.serialIn = data.serialIn;
    if (data.customerOrderServ)
      existParams.customerOrderServ = data.customerOrderServ;
    if (data.document9r1) existParams.document9r1 = data.document9r1;

    const newData = {
      ...data,
    };
    const response = await api.post("orders", newData);
    return response.data;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const createGroup = async (data: {
  orderId: number;
  description: string;
  visible: boolean;
}) => {
  try {
    const response = await api.post("image-groups", data);
    return response.data;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const getInDataAndCustomer = async (customerOrderNoserv: string) => {
  try {
    const response = await api.get(
      `orders/by-customer-order-noserv?customerOrderNoserv=${customerOrderNoserv}`,
    );
    if (response.status === 204) {
      throw new Error(literals.notFound);
    }
    return response.data;
  } catch (error) {
    if (error instanceof Error && error.message === literals.notFound) {
      throw error;
    } else if (isAxiosError(error) && error.response) {
      if (error instanceof Error && error.message === literals.notFound) {
        throw error;
      } else if (error.response.status === 404) {
        throw new Error(literals.notFound);
      }
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const getOrderDataBySapOrderNumber = async (orderNumber: string) => {
  try {
    const response = await api.get(
      `orders/by-sap-work-order-reception?sapWorkOrder=${orderNumber}`,
    );
    if (response.status === 204) {
      throw new Error(literals.notFound);
    }
    return response.data;
  } catch (error) {
    if (error instanceof Error && error.message === literals.notFound) {
      throw error;
    } else if (isAxiosError(error) && error.response) {
      if (error instanceof Error && error.message === literals.notFound) {
        throw error;
      } else if (error.response.status === 404) {
        throw new Error(literals.notFound);
      }
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const getPackagingOrderInfo = async (
  step: string,
  document9r1: string,
) => {
  try {
    const response = await api.get(
      `orders/packaging-info?step=${step}&document9r1=${document9r1}`,
    );
    if (response.status === 204) {
      throw new Error(literals.notFound);
    }
    return response.data;
  } catch (error) {
    if (error instanceof Error && error.message === literals.notFound) {
      throw error;
    } else if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error(literals.notFound);
      }
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};

export const sendEditionRequest = async (
  imageId: number,
  editionRequest: string,
) => {
  try {
    const { data } = await api.post(
      `order-edition-requests/orders/${imageId}`,
      {
        editionRequest: editionRequest.trim(),
      },
    );
    return data;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Ha habido un problema");
  }
};
